export function clearHighlight(force) {
    highlightFunctions.clearHighlight(force);
}
export function highlight(feature, persistent) {
    highlightFunctions.highlight(feature, persistent);
}
export function unhighlight(feature) {
    highlightFunctions.unhighlight(feature);
}
export function highlightPosition(coordinates, iconFileName) {
    return highlightFunctions.highlightPosition(coordinates, iconFileName);
}
let highlightFunctions = {
    clearHighlight(force) { },
    highlight(feature, persistent) { },
    unhighlight(feature) { },
    highlightPosition(coordinate) {
        return undefined;
    },
};
export function setHighlightFunctions(fns) {
    highlightFunctions = fns;
}
//# sourceMappingURL=proxy-highlight.js.map